
import React from "react";
import { CalendarDays } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { TrainingDay } from "./TrainingDay";

interface TrainingWeekProps {
  week: any;
  weekIndex: number;
}

function TrainingWeekComponent({ week, weekIndex }: TrainingWeekProps) {
  return (
    <AccordionItem 
      value={`week-${weekIndex}`}
      className="border border-white/20 rounded-md overflow-hidden bg-white/5"
    >
      <AccordionTrigger className="px-4 py-3 hover:bg-white/10 text-white">
        <div className="flex items-center gap-2">
          <CalendarDays className="h-4 w-4 text-white/70" />
          <span className="font-medium">Week {week.week_number || weekIndex + 1}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        {week.days && week.days.length > 0 ? (
          <Accordion type="multiple" className="space-y-2">
            {week.days.map((day: any, dayIndex: number) => (
              <TrainingDay 
                key={dayIndex} 
                day={day} 
                dayIndex={dayIndex} 
                weekIndex={weekIndex} 
              />
            ))}
          </Accordion>
        ) : (
          <p className="text-white/70 text-center py-2">No days defined for this week</p>
        )}
      </AccordionContent>
    </AccordionItem>
  );
}

// Apply memoization as week data rarely changes after initial load
export const TrainingWeek = React.memo(TrainingWeekComponent);
